import { render, staticRenderFns } from "./component-f80cbcd0.vue?vue&type=template&id=168f958f&scoped=true&"
import script from "./component-f80cbcd0.vue?vue&type=script&lang=js&"
export * from "./component-f80cbcd0.vue?vue&type=script&lang=js&"
import style0 from "./component-f80cbcd0.vue?vue&type=style&index=0&id=168f958f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f958f",
  null
  
)

export default component.exports